import apiClient from 'services/axios'
import store from 'store'
import jwt from 'jsonwebtoken'

export async function login(email, password) {
  return apiClient
    .post('/users/login', {
      email,
      password,
    })
    .then(response => {
      if (response.status !== 200) {
        return false
      }
      console.log('login response', response)
      const { token } = response.data.data
      if (token.auth) {
        // get token data and store them in the
        const { payload } = jwt.decode(token.auth, { complete: true })
        setStoreValue(payload, token)
      }
      return response.data.data
    })
    .catch(err => {
      throw new Error('Error during login process', err)
    })
}

export async function register(email, password, firstName, lastName) {
  return apiClient
    .post('/users/register', {
      email,
      password,
      firstName,
      lastName,
    })
    .then(response => {
      if (response) {
        const { token } = response.data.data
        if (token.auth) {
          const { payload } = jwt.decode(token.auth, { complete: true })
          setStoreValue(payload, token)
        }
        return response.data.data
      }
      return false
    })
    .catch(err => console.log('Register error', JSON.stringify(err)))
}

export async function currentAccount() {
  return apiClient
    .get('/users/me')
    .then(response => {
      if (response) {
        console.log('response data', response.data)
        const { token, user } = response.data.data
        if (token && user) {
          const { payload } = jwt.decode(token.auth, { complete: true })

          jwt.verify(token.auth, process.env.REACT_APP_JWT_SECRET, err => {
            if (err.name === 'TokenExpiredError') {
              console.log('Need to send a request for a new token')
              // use token.renew
            }
          })

          setStoreValue(payload, token)
        }
        return response.data.data
      }
      return false
    })
    .catch(err => {
      console.log('/me error', err)
      return false
    })
}

export async function logout() {
  return apiClient
    .get('/users/logout')
    .then(() => {
      store.remove('authToken')
      store.clearAll()
      return true
    })
    .catch(err => console.log(err))
}

function setStoreValue(payload, token) {
  store.set('authToken', token.auth)
  store.set('renewToken', token.renew)
  store.set('subscriptionPlan', payload.subscriptionPlan)
  store.set('onBoarding', payload.onBoarding)
  store.set('search', payload.searchApi)
}
